import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dashboard from './Dashboard';
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import { toast } from "react-toastify";
import { Grid, IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import FormControl from '@mui/material/FormControl';
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import Divider from '@mui/material/Divider';

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order,
      orderBy,
      t
    } = this.props;
    const currentLang = localStorage.getItem('i18nextLng');

    const rows = [
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Temperature.Store"), padding: '10px' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Temperature.Location"), padding: '10px' },
      currentLang === 'en' && { id: "side", numeric: false, disablePadding: false, label: t("Report.Temperature.Side"), padding: '10px' },
      { id: "port", numeric: false, disablePadding: false, label: t("Report.Temperature.Port"), padding: '10px' },
      { id: "temperature", numeric: false, disablePadding: false, label: t("Report.Temperature.Temperature"), padding: '10px', textAlign: 'center' },
      { id: "connectwith", numeric: false, disablePadding: false, label: t("Report.Temperature.ConnectWith"), padding: '10px' },
      { id: "action", numeric: false, disablePadding: false, label: "", padding: '10px' },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
              >
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

const styles = theme => ({
  root: {
    width: "100%",
    position: 'relative'
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '10px'
  }
  ,
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    borderRadius: '5px',
    fontSize: 'large',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
      borderRadius: '5px',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
      borderRadius: '5px',
    }
  }
});

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 5,
      loader: false,
      isDataEmpty: true,
      selectedObject: null,
      isUserValidate: false,
      dashboardData: [[]],
      storeData: [],
      startDate: '',
      endDate: '',
      isDownloadInProcess: false,
      fromdate: null,
      todate: null,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
    };
  }

  componentDidMount() {
    this.setState({ loader: true });
    this.getDashboardData();
  }

  fetchDashboardData = async (data) => {
    const history = await fetch(process.env.REACT_APP_BASEURL + 'temperature/history/by/expansion', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(res => {
        return res;
      })
    return history;
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }
  getDashboardData = () => {
    fetch(process.env.REACT_APP_BASEURL + 'temperature/monitoring/report', {
      method: 'get',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(async (res) => {
        this.setState({ storeData: res });
        const id = [];
        for (let i = 0; i < res.length; i++) {
          id.push(res[i].expansionId)
        }

        let startDate = new Date();
        startDate.toLocaleString();
        startDate.setDate(startDate.getDate() - 3);
        let endDate = new Date();
        endDate.toLocaleDateString();
        let data = {
          "startdate": startDate,
          "enddate": endDate,
          "expansionId": id,
          "parent_account_id": sessionStorage.getItem('parentAccountId')
        }
        this.setState({ startDate: startDate, endDate: endDate })
        let chartHistory = []
        for (let i = 0; i < id.length; i++) {
          data.expansionId = id[i];
          let item = {};
          item[id[i]] = await this.fetchDashboardData(data);
          chartHistory.push(item);
        }
        this.setState({ dashboardData: chartHistory, loader: chartHistory && chartHistory.total && false });
      });
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };


  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };


  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  downloadPopup = (event, n) => {
    const requestObj = {
      fromdate: moment(this.state.fromdate).tz(timeZone),
      todate: moment(this.state.todate).tz(timeZone),
      expansionId: n.expansionId,
      parent_account_id: sessionStorage.getItem('parentAccountId')
    }
    event && event.preventDefault();
    if (requestObj.fromdate === undefined || requestObj.fromdate === null || requestObj.fromdate === "") {
      toast.error(this.props.t('Toast.Error.SelectFromDate'));
      return;
    }
    if (requestObj.todate === undefined || requestObj.todate === null || requestObj.todate === "") {
      toast.error(this.props.t('Toast.Error.SelectToDate'));
      return;
    }
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/TemperatureHistoryReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestObj)
  })
  .then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    })
    .then(res => {
      this.setState({ loader: false });
      let csvRow=[];
      let A=[[`Id`,'Store','Location','Side','Temperature','Connect With', 'Date']];
      let re = res && res.Results && res.Results.length > 0 ? res.Results : [];
      if(re !== undefined){
        if(re && re.length > 0){
          for(let item=0; item < re.length; item++){
            A.push([
                n && n.store,
                n && n.box,
                n && n.side === 1 ? 'Left' : 'Right',
                re[item].temperature,
                n && n.connectedWith,
                re[item].temperature_timestamp ? this.convertToTimeZone(re[item].temperature_timestamp): '',
            ]);
          }
          for(let i=0; i<A.length; i++){
            csvRow.push(A[i].join(","));
          }
          let csvString=csvRow.join("%0A");
          let a = document.createElement("a");
          a.href='data:attachment/csv.'+csvString;
          a.target="_Blank";
          a.download="TemperatureMonitoring.csv";
          document.body.appendChild(a);
          a.click();
        }
      }
    })
  }

  onFromDateSelect = date => {
    date = date ? moment(moment(date).format('YYYY-MM-DD')) : '';
    this.setState({ fromdate: date });
  };

  onToDateSelect = date => {
    date = date ? moment(moment(date).format('YYYY-MM-DD') + ' 23:59:59') : '';
    this.setState({ todate: date });
  };

  render() {
    const { classes, t } = this.props;
    const { storeData, order, orderBy, rowsPerPage, page, fromdate, todate, locale } = this.state;
    const currentLang = localStorage.getItem('i18nextLng');
    return (
      <div>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div>
          <Grid container spacing={3} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={8} sm={8} style={{ paddingRight: '1%' }}/>
            <Grid item xs={2} sm={2} style={{ paddingRight: '1%' }}>
            <FormControl sx={{ width: '100%' }}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
              <DesktopDatePicker
                    keyboard
                    disableFuture
                    format="MM/dd/yyyy"
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Report.Temperature.FromDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurfrom}
                      />}
                    value={fromdate}
                    onChange={this.onFromDateSelect}
                  />
              </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={2} sm={2} style={{ paddingLeft: '1%' }}>
            <FormControl sx={{ width: '100%' }}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
              <DesktopDatePicker
                    keyboard
                    label={t("Report.Temperature.ToDate")}
                    disableFuture
                    format="MM/dd/yyyy"
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Report.Temperature.ToDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurtodate}
                      />}
                    value={todate}
                    onChange={this.onToDateSelect}
                  />
            </LocalizationProvider>
            </FormControl>
            </Grid>
          </Grid>
        </div>
        <Divider style={{ marginTop: '10px', height: '5px' }} />
         <div className={classes.tableWrapper}>
           <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
            />
             <TableBody>
              {!storeData ?
                (<TableRow>
                  <TableCell colSpan={16} style={{ textAlign: "center", padding:'10px 0px' }}>
                    {this.state.isDataEmpty && t("Report.Temperature.NoDataFound")}
                  </TableCell>
                </TableRow>) : stableSort(storeData, getSorting(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(n => {
                    return (
                      <TableRow key={n.expansionId}>
                        <TableCell className={classes.padding10px}>{n.store}</TableCell>
                        <TableCell className={classes.padding10px}>{n.box}</TableCell>
                        {currentLang === 'en' && (<TableCell className={classes.padding10px}>{n.side}</TableCell>)}
                        <TableCell className={classes.padding10px}>{n.comPort}</TableCell>
                        <TableCell className={classes.padding10px} style={{ width: '300px' }}>
                          {
                            // eslint-disable-next-line
                            (this.state && this.state.dashboardData && this.state.dashboardData.map && this.state.dashboardData.map((item) => {
                              if (n.expansionId === Object.keys(item)[0]) {
                                return <Dashboard
                                  margin="2%"
                                  key={Object.keys(item)[0]}
                                  data={item && item[n.expansionId]}
                                  startDate={this.state.startDate}
                                  endDate={this.state.endDate}
                                  convertTimeZone={this.convertToTimeZone}
                                  tempUnit={n.tempUnit}
                                />
                              }
                            }))
                          }
                        </TableCell>
                        <TableCell className={classes.padding10px} >{n.connectedWith}</TableCell>
                        <TableCell>
                          <Tooltip key="single-edit" title={t("Report.Temperature.DownloadReportButton")}>
                            <IconButton
                              aria-label="downloadreport"
                              onClick={(event) => this.downloadPopup(event, n)}
                              style={{ fontSize: '2rem' }}
                              sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } }) }
                            >
                              <DownloadForOfflineOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={storeData ? storeData.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/temparature_monitoring/index.js